<!-- <mat-tab-group fxFlex="1 1 100%" class="m-12">
    <mat-tab *ngIf="permissionViewInDocument" 
    label="{{'FILE-MANAGER.TABS.IN' | translate}}" 
    fxLayout="column" #matTabIn>
        
    </mat-tab>
</mat-tab-group> -->

<div fxFlex="1 1 100%" class="m-12" fxLayout="column">
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start center">

            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="pt-8">
                <!--DOWNLOAD ALL FILES-->
                <div fxLayout="row" fxLayoutAlign="flex-start center"  fxLayoutAlign.lt-md="center center"
                    *ngIf="showDownloadAllFiles && showDownloadAllInFiles" class="mr-8">
                    <button mat-mini-fab color="accent" (click)="downloadAllFiles('IN')"
                        matTooltip="{{'FILE-MANAGER.ALL-FILES-IN' | translate}}" matTooltipPosition="above">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                </div>
                <!-- <div fxLayout="row" fxLayoutAlign="flex-start center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center"
                    *ngIf="permissionManageInFiles" class="mr-8">
                    <button mat-raised-button class="" color="accent" (click)="openLinkDialog('IN')">
                        <mat-icon class="ml-4">link</mat-icon>
                        <span class="mx-4">{{'FILE-MANAGER.LINK' | translate}}</span>
                    </button>
                </div> -->
                <div *ngIf="permissionManageInFiles"
                fxLayout="row" fxFlex fxLayoutAlign="flex-start center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center">
                    <button mat-raised-button class="" color="accent" (click)="onClickFileInput('IN')">
                        <mat-icon class="ml-4">insert_drive_file</mat-icon>
                        <span class="mx-4">{{'FILE-MANAGER.FILE' | translate}}</span>
                    </button>
                </div>
            </div>

            <!--DRAG N DROP FILES-->
            <div fxFlex="100%" *ngIf="permissionManageInFiles">
                <div class="uploadfilecontainer" appDragDrop (fileDropped)="onFileInUpload($event)"
                    (click)="fileInInput.click()" fxLayout="row" fxLayoutAlign="center center">
                    <input hidden type="file" id="fileInInput" multiple #fileInInput [accept]="extensions"
                        (change)="onFileInUpload($event.target.files)" />
                    <span class="logo-text h3" fxFlex fxLayout="row" fxLayoutAlign="center center">

                        <div *ngIf="!spinnerDisplay" fxLayoutAlign="flex-start center">
                            <mat-icon class="mr-8">cloud_upload</mat-icon>{{'FILE-MANAGER.MASSIVE' | translate}}
                        </div>

                        <div *ngIf="spinnerDisplay" fxLayout="row" fxLayoutAlign="center center">
                            <span>
                                {{'FILE-MANAGER.FILE-PROCESSING' | translate}} {{filesProcessed}}
                                {{'FILE-MANAGER.FILE-OUTOF' | translate}} {{filesQueue}}
                            </span>
                            <mat-progress-spinner color="primary" mode="indeterminate" diameter="15" class="mx-12">
                            </mat-progress-spinner>
                        </div>
                    </span>
                </div>
            </div>
            <div *ngIf="permissionManageInFiles">
                <span> {{'FILE-MANAGER.FILE-EXTENSION' | translate}} {{extensions}}</span>
            </div>
        </div>
        <!--FILES TABLE-->
        <div *ngIf="dataSourceFiles.data.length" fxFlex="1 1 100%" fusePerfectScrollbar class="py-16">
            <h4><strong>{{'FILE-MANAGER.TITLE' | translate}}</strong></h4>
            <!--FILES CREATE SELECTED-->
            <mat-table #tableCreate [dataSource]="dataSourceFiles" [@animateStagger]="{value:'50'}">

                <!-- icon Column -->
                <ng-container matColumnDef="icon">
                    <mat-header-cell *matHeaderCellDef fxFlex="128px"></mat-header-cell>
                    <mat-cell *matCellDef="let row" fxFlex="128px">
                        <mat-icon color="accent">insert_drive_file</mat-icon>
                        <!-- <mat-icon *ngIf="row.type != 'File'" color="accent">link</mat-icon> -->
                        <!-- <img  class="p-8 cursor-pointer" style="width: 128px; height: 128px;"  (click)="getFileById(row.id, row.name)"
                         src="{{'data:image/jpg;base64,' + row.file}}" /> -->
                    </mat-cell>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef  class="ml-16"></mat-header-cell>
                    <mat-cell *matCellDef="let row"  class="ml-16">
                        <span class="cursor-pointer"
                            (click)="getFileById(row.id)">{{row.name}}</span>
                        <!-- <a *ngIf="row.type != 'File'" [href]="urlFormat(row.url)" target="_blank">{{row.name}}</a> -->
                    </mat-cell>
                </ng-container>

                <!-- type Column -->
                <ng-container matColumnDef="type">
                    <mat-header-cell *matHeaderCellDef fxFlex="100px">{{'FILE-MANAGER.TABLE.TYPE' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" fxFlex="100px"> {{row.fileExtension || 'URL'}}</mat-cell>
                </ng-container>

                <!-- owner Column -->
                <!-- <ng-container matColumnDef="owner">
                        <mat-header-cell *matHeaderCellDef>{{'FILE-MANAGER.TABLE.USER' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.collaboratorDescription}}</mat-cell>
                    </ng-container> -->

                <!-- Size Column -->
                <ng-container matColumnDef="size">
                    <mat-header-cell *matHeaderCellDef fxFlex="100px">{{'FILE-MANAGER.TABLE.SIZE' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" fxFlex="100px">{{row.fileSizeFormatted}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef fxFlex="70px"></mat-header-cell>
                    <mat-cell *matCellDef="let row" fxFlex="70px">
                        <button *ngIf="row.canDelete || permissionDeleteInFiles" mat-icon-button
                            matTooltip="Quitar" matTooltipPosition="above" (click)="dropRow(row, 'IN')">
                            <mat-icon class="drop_row">
                                close
                            </mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="noRecord">
                    <mat-footer-cell *matFooterCellDef>
                        <div style="width: 100%;text-align: center;">{{'FILE-MANAGER.TABLE.EMPTY' | translate}}</div>
                    </mat-footer-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedFilesColumns;"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedFilesColumns;"
                    [ngClass]="{'selected' : row == selected}" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
                </mat-row>

                <mat-footer-row *matFooterRowDef="['noRecord']"
                    [hidden]="dataSourceFiles.data.length">
                </mat-footer-row>
            </mat-table>
            <!--/ FILES SELECTED-->
        </div>
</div>
